import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from 'app';
// import reports from 'reports';

import 'assets/styles/index.scss';

const container = document.getElementById('root')!;
createRoot(container).render(
  <StrictMode>
    <App container={container} />
  </StrictMode>
);

// reports((metrics: any) => console.log('[RPT]', metrics));
